<div class="account-info-header">
  <div class="mm-left-column">
    <sac-ng-tab-header (refresh)="handleRefresh()" [showRefresh]="true" [asOfDate]="updatedTimestamp"></sac-ng-tab-header>
  </div>
</div>
